import { __assign, __rest } from "tslib";
import React from 'react';
import VeltVideoPlayerControlsTogglePauseWireframe from './VeltVideoPlayerControlsTogglePauseWireframe/VeltVideoPlayerControlsTogglePauseWireframe';
import VeltVideoPlayerControlsTogglePlayWireframe from './VeltVideoPlayerControlsTogglePlayWireframe/VeltVideoPlayerControlsTogglePlayWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltVideoPlayerControlsToggleButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-toggle-button-wireframe", __assign({}, transformedProps), children));
};
VeltVideoPlayerControlsToggleButtonWireframe.Play = VeltVideoPlayerControlsTogglePlayWireframe;
VeltVideoPlayerControlsToggleButtonWireframe.Pause = VeltVideoPlayerControlsTogglePauseWireframe;
export default VeltVideoPlayerControlsToggleButtonWireframe;
